/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { WebpageRefDisplay } from "./display";
import { WebpageRefEdit } from "./edit";

const WebpageRefField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <WebpageRefDisplay />,
        editComponent: <WebpageRefEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
WebpageRefField.displayName = "WebpageRefField";
export { WebpageRefField };
